import { schema } from 'normalizr';
import { MentorshipProgramSession } from 'redux/schemas/models/mentoring-program-sessions';

export const MentorshipProgramSessionSchema = new schema.Entity<MentorshipProgramSession>('mentorshipProgramSessions');

export const MentorshipProgramSessionsSchema = new schema.Array(MentorshipProgramSessionSchema);
